import { render, staticRenderFns } from "./CongressmanBillPage.vue?vue&type=template&id=7e4be694&scoped=true"
import script from "./CongressmanBillPage.vue?vue&type=script&lang=js"
export * from "./CongressmanBillPage.vue?vue&type=script&lang=js"
import style0 from "./CongressmanBillPage.vue?vue&type=style&index=0&id=7e4be694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4be694",
  null
  
)

export default component.exports